<template>
  <v-container grid-list-xl>
    <v-layout wrap>
      <v-flex xs12 class="headline">My Tool Orders</v-flex>
      <v-flex xs12>
        <v-card>
          <v-tabs>
            <v-tab @click="open = true">Open Orders</v-tab>
            <v-tab @click="open = false">fulfilled Orders</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <tool-orders-table
            v-if="toolOrders"
            :toolOrders="open ? openOrders : fulfilledOrders"
            :loading="loading"
            :headers="headers"
          />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import fb from "@/main";
import ToolOrdersTable from "@/components/toolOrders/ToolOrdersTable";
export default {
  components: { ToolOrdersTable },
  data() {
    return {
      toolOrders: [],
      open: true,
      loading: true,
      headers: [
        {
          text: "Order",
          align: "left",
          value: "orderNumber",
        },
        {
          text: "Site Address",
          align: "left",
          value: "jobSite.address",
        },
        { text: "Fulfillment", value: "fulfilled" },
        { text: "Date", value: "orderDate" },
        { text: "", value: "viewOrder", align: "right" },
      ],
    };
  },
  async created() {
    try {
      this.loading = true;
      const user = this.$store.getters["user"];
      const toolOrders = await fb.db
        .collection("toolOrders")
        .where("orderedBy.uid", "==", user.uid)
        .limit(50)
        .orderBy("orderDate", "desc")
        .get();
      this.toolOrders = [];
      toolOrders.forEach((u) => {
        this.toolOrders.push({
          id: u.id,
          ...u.data(),
        });
      });
      this.loading = false;
    } catch (err) {
      console.log(err);
      alert("Error getting orders");
      this.loading = false;
    }
  },
  computed: {
    openOrders() {
      return this.toolOrders.filter((o) => {
        return !o.fulfilled && !o.cancelled;
      });
    },
    fulfilledOrders() {
      return this.toolOrders.filter((o) => o.fulfilled);
    },
  },
};
</script>
